import { useSelector } from "react-redux";
import DateInput from "../../../components/common/inputs/DateInput";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";

export default function CourseEnrollmentsReportsFilter({
  filterDataHandler,
}) {
  const { utils } = useSelector(utilsState);

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="admin-filter-grid">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
        <label className="flex flex-col gap-2 text-sm dark:text-white">شناسه کاربر
          <input className="admin-field" onChange={(e) => filterDataHandler({ user: e.target.value })} />
        </label>
        <label className="flex flex-col gap-2 text-sm dark:text-white">شناسه دوره
          <input className="admin-field" onChange={(e) => filterDataHandler({ course: e.target.value })} />
        </label>
        <label className="flex flex-col gap-2 text-sm dark:text-white">ثبت‌نام ادمین
          <select className="admin-field" onChange={(e) => filterDataHandler({ isAdminRegistration: e.target.value })}>
            <option value="">همه</option><option value="true">بله</option><option value="false">خیر</option>
          </select>
        </label>
            <div className="relative">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
           وضعیت پرداخت
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, paymentStatus: e.target.value })
            }
            className="backdrop-blur block w-full sm:w-auto p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>{"وضعیت پرداخت"}</option>
            <option value={""}>{"همه"}</option>
            {utils &&
              utils?.PAYMENT_STATUS_VALUES.map((item) => {
                if (item.value == utils?.PAYMENT_STATUS?.done?.value) {
                  return (
                    <option selected="selected" value={item.value}>
                      {item.name}
                    </option>
                  );
                } else {
                  return <option value={item.value}>{item.name}</option>;
                }
              })}
          </select>
        </div>
      </div>
    </div>
  );
}
